import { breakpoints } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

const TabWrapper = styled.div`
  @media (min-width: ${breakpoints.md}) {
    margin: 0;
  }
`;

export default TabWrapper;
